// @flow

// phase1 からコピーする

const WidgetName = 'pop-ask';
const URL_IMPLEMENTATION_MANUAL =
  'https://confluence.rakuten-it.com/confluence/x/hDSVaw';
const URL_GENERATOR_MANUAL =
  'https://confluence.rakuten-it.com/confluence/x/RshCb';

export const ErrorCodes = Object.freeze({
  // 100: Unknown
  ERR_UNKNOWN: 100,

  // 2xx: html implementation related
  ERR_NO_ROOT_ELEMENT: 200,
  ERR_NO_CONFIG: 201,

  // 3xx: Config object related
  ERR_NO_SURVEY_ID: 300,

  // 4xx: Generator related
  ERR_GENERATOR_TBD: 400,
});
type ErrorCodeType = $Values<typeof ErrorCodes>; // type ErrorCodeType = 100 | 200;

const ErrorDescriptions = Object.freeze({
  [ErrorCodes.ERR_UNKNOWN]: 'Unknown error',
  [ErrorCodes.ERR_NO_ROOT_ELEMENT]:
    'There is no DOM element with `id="rexSurveyRoot"` on this page',
  [ErrorCodes.ERR_NO_CONFIG]:
    'There is no configuration object named "rexSurveyConfig" on this page',
  [ErrorCodes.ERR_NO_SURVEY_ID]:
    '`surveyId` is not defined in "rexSurveyConfig"',
  [ErrorCodes.ERR_GENERATOR_TBD]: 'This is reserved error for generator',
});

const ErrorDetailURLs = Object.freeze({
  [ErrorCodes.ERR_NO_ROOT_ELEMENT]: URL_IMPLEMENTATION_MANUAL,
  [ErrorCodes.ERR_NO_CONFIG]: URL_IMPLEMENTATION_MANUAL,
  [ErrorCodes.ERR_GENERATOR_TBD]: URL_GENERATOR_MANUAL,
});

const CachedBindings = {};

type WarningReturnValueType = (message?: any, ...optionalParams: any[]) => void;

/**
 * getErrorMessages
 */
const getErrorMessages = (errorCode: ErrorCodeType): string[] => {
  const description = ErrorDescriptions[errorCode];
  const detailURL = ErrorDetailURLs[errorCode];
  const message = detailURL
    ? `${description}. \nSee: ${detailURL}`
    : `${description}.`;

  return [`[${WidgetName}]`, `#${errorCode}`, message];
};

/**
 * warning
 */
export const warning = (
  errorCode?: ErrorCodeType = ErrorCodes.ERR_UNKNOWN
): WarningReturnValueType => {
  if (CachedBindings[errorCode]) return CachedBindings[errorCode];

  const errorMessages = getErrorMessages(errorCode);

  return (CachedBindings[errorCode] = console.warn.bind(
    window.console,
    ...errorMessages
  ));
};

// /**
//  * getError
//  */
// export const getError = (errorCode: ErrorCodeType): Error => {
//   const errorMessages = getErrorMessages(errorCode);
//   return new Error(errorMessages.join(' '));
// };



// WEBPACK FOOTER //
// ./src/phase2/survey/app/warning.js